import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { layoutSetHighStep, layoutSetSteps } from "layout/_redux/actions";
import { layoutStepsSelector } from "layout/_redux/selectors";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { OnboardingSteps } from "./config";
import OnBoardingRouter from "./onBoarding-router";

const OnBoardingPage: React.FC = () => {
	const dispatch = useAppDispatch();

	const location = useLocation();

	const steps = useAppSelector(layoutStepsSelector);

	useEffect(() => {
		dispatch(layoutSetSteps(OnboardingSteps));
	}, []);

	useEffect(() => {
		let currentStep = steps?.find(
			(s) =>
				s?.route == location.pathname || s?.subSteps?.find((ss) => ss?.route == location.pathname)
		);

		if (currentStep) dispatch(layoutSetHighStep(currentStep));
	}, [location]);

	return <OnBoardingRouter />;
};
export default OnBoardingPage;
